module.exports = __webpack_public_path__ + "static/img/6401_phase_function_Paper_Points.99fce23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6401_phase_function_Paper_Points.png
// module id = DerW
// module chunks = 0